<ng-container *ngIf="activatableItems$ | async as activatableItems; else loadingItems">
  <div class="search-container">
    <div class="search-child">
      <va-search-box
        [highlightWhenSelected]="true"
        [disabled]="false"
        (update)="onProductSearchTermChanged($event)"
        (submit)="onProductSearchTermChanged($event)"
      ></va-search-box>
    </div>
    <div class="search-child toggle-restricted" *ngIf="hasUnavailableItems$ | async">
      <a (click)="toggleRestrictedItems()">
        {{
          ((showingRestrictedProducts$ | async)
            ? 'APP_SELECTION.ACTIVATION_TABLE.HIDE_UNAVAILABLE'
            : 'APP_SELECTION.ACTIVATION_TABLE.SHOW_UNAVAILABLE'
          ) | translate
        }}
      </a>
    </div>
  </div>
  <div class="table-body">
    <app-activation-table
      *ngIf="activatableItems.length > 0; else noProducts"
      [activatableItems]="activatableItems"
      [hidePricing]="hidePricing$ | async"
      [features]="features"
      (sortChanged)="onProductSortOrderChanged($event)"
      (itemCheckboxClicked)="onItemSelected($event)"
    ></app-activation-table>
  </div>
  <div class="table-footer">
    <mat-paginator
      [length]="totalItems$ | async"
      [pageSize]="50"
      [pageSizeOptions]="pageOptions$ | async"
      (page)="onProductPage($event)"
    ></mat-paginator>
  </div>
</ng-container>

<ng-template #loadingItems>
  <uikit-list-stencil [numRows]="8"></uikit-list-stencil>
</ng-template>
<ng-template #noProducts>
  <p class="no-packages-text">
    {{ 'APP_SELECTION.ACTIVATION_TABLE.NO_PRODUCTS' | translate }}
    <a routerLink="/marketplace/products">
      {{ 'APP_SELECTION.ACTIVATION_TABLE.VIEW_AND_ENABLE_PRODUCTS' | translate }}
    </a>
  </p>
</ng-template>
